import * as React from 'react';

var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgFacebookIcon = function SvgFacebookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#3B5998"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M301.6 151.2h36.3V97h-51.4c-29.6 0-68.1 19-68.1 74.2v43h-49.1v56.1h49.1v146H277v-146h48.8l8.1-56.1H277v-35.7c0-18.4 9-27.3 24.6-27.3"
  }))));
};

export { SvgFacebookIcon as default };
